import ImageWrapper, { ImageWrapperProps } from './ImageWrapper';

export default ImageWrapper;

export { ImageWrapperProps };
